import { useLocation } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { MouseEvent } from 'react';

interface NavigationItem {
  name: string;
  href: string;
  icon: React.ComponentType;
  enabled: boolean;
}

export function useNavigation(onNavigate?: () => void) {
  const location = useLocation();
  const { toast } = useToast();

  const handleNavigation = (e: MouseEvent, item: NavigationItem) => {
    if (!item.enabled) {
      e.preventDefault();
      toast({
        title: "Coming Soon",
        description: `The ${item.name} feature is coming soon!`,
        duration: 2000
      });
    } else if (onNavigate) {
      onNavigate();
    }
  };

  return {
    currentPath: location.pathname,
    handleNavigation
  };
}